<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="pageiii"></a>Family Favorite<br/>Casserole Recipes</h1>
<p class="titletext"><strong><em>103 Comforting Breakfast Casseroles,<br/>Dinner Ideas, and Desserts<br/>Everyone Will Love</em></strong></p>
<h4 class="authora">Addie Gundry</h4>
<p class="logo"><a id="page2"></a><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?cdd36bee